import { render, staticRenderFns } from "./RegraNegocio.vue?vue&type=template&id=eeb0bd78"
import script from "./RegraNegocio.vue?vue&type=script&lang=js"
export * from "./RegraNegocio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports